export default __webpack_public_path__ + "static/media/Pilgrim's Jerkin of the Purple Sun.ae993a35.jpg";